/* globals Store */
import Vue from 'vue'
import Router from 'vue-router'
import ErrorPage from '@/components/404'

import Dashboard from '@/pages/Dashboard'
import Account from '@/pages/Account'
import Calendar from '@/pages/Calendar'
import Profile from '@/pages/Profile'
import Packages from '@/pages/Packages'
import Help from '@/pages/Help'
import Welcome from '@/pages/Welcome'
import ProfileCompletion from '@/pages/ProfileCompletion'

import auth from '@/utils/auth'
import Login from '@/components/Login'
import Signup from '@/components/Signup'
import Logout from '@/components/Logout'
import ForgotPassword from '@/components/ForgotPassword'
// import ChangePassword from '@/components/ChangePassword'

Vue.use(Router)

// required for stepper page etc
function requireAuthWithProfileMode (to, from, next) {
  if (Store.state.project.snackbar) {
    Store.dispatch('project/closeNotice')
  }
  if (!auth.loggedIn()) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else if (!auth.profileMode()) {
    // for stepper page we expect mode to be true
    next('/dashboard')
  } else {
    next()
  }
}

// required for dashboard etc
function requireAuthWithoutProfileMode (to, from, next) {
  if (Store.state.project.snackbar) {
    Store.dispatch('project/closeNotice')
  }
  if (!auth.loggedIn()) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else if (auth.profileMode()) {
    // for dashboard we expect mode to be false
    next('/welcome')
  } else {
    next()
  }
}

// not allowed when loggedIn (SignUp, Login, etc)
function notAllowedWhenLoggedIn (to, from, next) {
  if (Store.state.project.snackbar) {
    Store.dispatch('project/closeNotice')
  }
  if (auth.loggedIn()) {
    next('/dashboard')
  } else {
    next()
  }
}

// const debug = process.env.NODE_ENV !== 'production'

export default new Router({
  base: __dirname,
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    { path: '/404', component: ErrorPage, name: 'ErrorPage' },
    { path: '/dashboard', component: Dashboard, name: 'Dashboard', beforeEnter: requireAuthWithoutProfileMode },
    { path: '/account', component: Account, name: 'Account', beforeEnter: requireAuthWithoutProfileMode },
    { path: '/calendar', component: Calendar, name: 'Calendar', beforeEnter: requireAuthWithoutProfileMode },
    { path: '/profile', component: Profile, name: 'Profile', beforeEnter: requireAuthWithoutProfileMode },
    { path: '/packages', component: Packages, name: 'Packages', beforeEnter: requireAuthWithoutProfileMode },
    { path: '/welcome', component: Welcome, name: 'Welcome', beforeEnter: requireAuthWithProfileMode },
    { path: '/help', component: Help, name: 'Help', beforeEnter: requireAuthWithoutProfileMode },
    { path: '/profile-completion', component: ProfileCompletion, name: 'Profile-Completion', beforeEnter: requireAuthWithProfileMode },
    { path: '/login', component: Login, name: 'Login', beforeEnter: notAllowedWhenLoggedIn },
    { path: '/signup', component: Signup, name: 'Signup', beforeEnter: notAllowedWhenLoggedIn },
    { path: '/forgotpassword', component: ForgotPassword, name: 'ForgotPassword', beforeEnter: notAllowedWhenLoggedIn },
    { path: '/logout',
      beforeEnter (to, from, next) {
        auth.logout()
        next()
      },
      component: Logout,
      name: 'Logout'
    },
    { path: '/', redirect: '/dashboard' },
    { path: '*', redirect: '/404' }
  ],
  meta: {
    progress: {
      func: [
        {call: 'color', modifier: 'temp', argument: '#ffb000'},
        {call: 'fail', modifier: 'temp', argument: '#6e0000'},
        {call: 'location', modifier: 'temp', argument: 'top'},
        {call: 'transition', modifier: 'temp', argument: {speed: '1.5s', opacity: '0.6s', termination: 400}}
      ]
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js